<template>
  <v-dialog v-model="show" max-width="1200" style="z-index:30000">
    <template v-slot:activator="{on}">
      <slot name="activator" :on="on">
        <v-btn v-on="on" tile outlined small>Recurring customers</v-btn>
      </slot>
    </template>
    <v-card>
      <v-card-title class="">
        Recurring Customers
      </v-card-title>
      <v-card-text>
        <v-data-table
            :headers="headers"
            :items="recurring"
            item-key="id"
        >
          <template v-slot:item.customer_id="{item}">
            {{ scheduledCustomerName(item.customer_id) }}
          </template>
          <template v-slot:item.days.sunday="{item}">
            <v-btn @click="toggleDay('sunday', item.id, item.days.sunday)" tile block icon small>
              <v-icon color="success" v-if="item.days.sunday">mdi-checkbox-marked</v-icon>
              <v-icon color="error" v-else>mdi-close-box</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.days.monday="{item}">
            <v-btn @click="toggleDay('monday', item.id, item.days.monday)" tile block icon small>
              <v-icon color="success" v-if="item.days.monday">mdi-checkbox-marked</v-icon>
              <v-icon color="error" v-else>mdi-close-box</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.days.tuesday="{item}">
            <v-btn @click="toggleDay('tuesday', item.id, item.days.tuesday)" tile block icon small>
              <v-icon color="success" v-if="item.days.tuesday">mdi-checkbox-marked</v-icon>
              <v-icon color="error" v-else>mdi-close-box</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.days.wednesday="{item}">
            <v-btn @click="toggleDay('wednesday', item.id, item.days.wednesday)" tile block icon small>
              <v-icon color="success" v-if="item.days.wednesday">mdi-checkbox-marked</v-icon>
              <v-icon color="error" v-else>mdi-close-box</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.days.thursday="{item}">
            <v-btn @click="toggleDay('thursday', item.id, item.days.thursday)" tile block icon small>
              <v-icon color="success" v-if="item.days.thursday">mdi-checkbox-marked</v-icon>
              <v-icon color="error" v-else>mdi-close-box</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.days.friday="{item}">
            <v-btn @click="toggleDay('friday', item.id, item.days.friday)" tile block icon small>
              <v-icon color="success" v-if="item.days.friday">mdi-checkbox-marked</v-icon>
              <v-icon color="error" v-else>mdi-close-box</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.days.saturday="{item}">
            <v-btn @click="toggleDay('saturday', item.id, item.days.saturday)" tile block icon small>
              <v-icon color="success" v-if="item.days.saturday">mdi-checkbox-marked</v-icon>
              <v-icon color="error" v-else>mdi-close-box</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
name: "RecurringCustomers",
  data: () => ({
    show: false,
    headers:[
      {text: "Customer", value: "customer_id",},
      {text: "sunday", value: "days.sunday", align: "center"},
      {text: "monday", value: "days.monday", align: "center"},
      {text: "tuesday", value: "days.tuesday", align: "center"},
      {text: "wednesday", value: "days.wednesday", align: "center"},
      {text: "thursday", value: "days.thursday", align: "center"},
      {text: "friday", value: "days.friday", align: "center"},
      {text: "saturday", value: "days.saturday", align: "center"},
    ]
  }),
  props: {
    recurring:{
      required: true,
    },
    names:{
      required: true,
    }
  },
  methods:{
    scheduledCustomerName(id){
      let name = this.names.filter(v => v.customer_id ===  id);
      return name.length > 0 ? name[0].name : "Not Synced";
    },
    toggleDay(day,id, bool){
      this.$firestore.collection('scheduled_recurring').doc(id).update({
        ['days.'+day]: !bool
      })
    }
  }
}
</script>

<style scoped>

</style>